import Button from "@mui/material/Button";
import { useState } from "react";
import { Modal } from "../modal/Modal";
import { AuthLoginDialog } from "./AuthLoginDialog";

export const AuthLoginButton = (props: any) => {
  const buttonName: string = props.name;
  const sx = props.sx;
  const variant = props.variant;
  const appName = props.appName;

  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant={variant}
        color="primary"
        size="small"
        sx={sx}
        onClick={() => {
          setOpen(true);
        }}
      >
        {buttonName}
      </Button>
      <Modal isOpen={open} closeCallback={() => setOpen(false)}>
        <AuthLoginDialog
          appName={appName}
          closeCallback={() => setOpen(false)}
        />
      </Modal>
    </>
  );
};
